import { Record } from "immutable";

type MetaType = {
  courseId?: string;
  shareTopicModalOpen: boolean;
};

export type OptionalMetaType = Partial<MetaType>;

const defualtMeta: MetaType = {
  courseId: undefined,
  shareTopicModalOpen: false
};

export default class Meta extends Record(defualtMeta) {}
